module.exports = __webpack_public_path__ + "img/thumb_17.a57a00b4.jpg";